/**
 * Menu a tendina della topbar nel layout split-screen.
 * Apre/chiude #split-menu, aggiorna aria-expanded, chiude su click link,
 * click fuori ed Esc. Non fa nulla se la topbar split non è presente.
 */
export default function splitMenu() {
	const toggle = document.getElementById('split-menu-toggle');
	const menu = document.getElementById('split-menu');

	if (!toggle || !menu) {
		return;
	}

	const setOpen = (open) => {
		menu.classList.toggle('is-open', open);
		toggle.setAttribute('aria-expanded', String(open));
	};

	toggle.addEventListener('click', (event) => {
		event.stopPropagation();
		setOpen(!menu.classList.contains('is-open'));
	});

	menu.querySelectorAll('a').forEach((link) => {
		link.addEventListener('click', () => setOpen(false));
	});

	document.addEventListener('click', (event) => {
		if (menu.classList.contains('is-open') && !menu.contains(event.target)) {
			setOpen(false);
		}
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && menu.classList.contains('is-open')) {
			setOpen(false);
			toggle.focus();
		}
	});
}
